import workspaceQuery from '../../queries/sales/CarriageCostsWorkspaceQuery.graphql';
import fragment from '../../fragments/sales/CarriageCostFragment.graphql';
import { EntityType } from '../../../@types/entityTypes';
import { ALLOW_VIEW } from '../../../utils/OperationPermissions';

const CarriageCost: EntityType = {
  type: 'CarriageCost',
  title: 'Carriage Cost',
  workspaceUrl: '/Sales/CarriageCost/Workspace',
  workspace: workspaceQuery,
  fragment,
  screenReference: 'CARRIAGE_COST',
  operations: ALLOW_VIEW,
};

export default CarriageCost;
